import styled from "styled-components";

export const PartyIntelWrapper = styled.div`
 // overflow: hidden;

`



